import { Apple, Download, Monitor } from 'lucide-react';
import { Card } from './ui';
import { CopyButton } from './CopyButton';
import { DESKTOP_DOWNLOADS } from '../lib/desktopReleases';

const linkButton =
  'inline-flex items-center justify-center gap-2 rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm font-medium text-slate-100 transition hover:bg-slate-800';

/**
 * The Firmio desktop app (Windows, macOS): where to download it and the same
 * organization code as the mobile app. The firmio://connect link opens the
 * installed app with the code filled in.
 */
export function DesktopAppCard({ slug, domain }: { slug: string; domain: string }) {
  const deepLink = `firmio://connect?code=${encodeURIComponent(slug)}`;
  return (
    <Card className="space-y-4">
      <div className="flex items-start gap-3">
        <Monitor className="mt-0.5 h-5 w-5 text-violet-300" />
        <div>
          <h2 className="text-sm font-semibold text-white">Aplicația desktop</h2>
          <p className="mt-1 text-xs text-slate-400">
            Firmio pentru Windows și macOS, cu notificări de sistem și cu fereastra închisă. La
            prima pornire se introduce codul organizației{' '}
            <span className="font-mono text-slate-300">{slug}</span>; aplicația deschide apoi{' '}
            <span className="text-slate-300">https://{domain}</span>.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <a className={linkButton} href={DESKTOP_DOWNLOADS.windows} rel="noreferrer">
          <Download className="h-4 w-4" /> Windows (.exe)
        </a>
        <a className={linkButton} href={DESKTOP_DOWNLOADS.mac} rel="noreferrer">
          <Apple className="h-4 w-4" /> macOS (.dmg)
        </a>
        <a
          className="inline-flex items-center px-1 text-sm text-violet-300 hover:underline"
          href={DESKTOP_DOWNLOADS.all}
          target="_blank"
          rel="noreferrer"
        >
          Toate versiunile
        </a>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <span className="block text-xs uppercase tracking-wide text-slate-400">
            Link care deschide aplicația cu codul completat
          </span>
          <code className="block truncate text-sm text-slate-300">{deepLink}</code>
        </div>
        <CopyButton text={deepLink} label="Copiază linkul aplicației desktop" />
      </div>

      <p className="text-xs text-slate-500">
        Prima versiune nu este semnată. Windows: „Windows a protejat PC-ul” → „Mai multe informații”
        → „Rulează oricum” (pe calculatoarele cu Smart App Control pornit, installerul nesemnat nu
        rulează deloc). macOS: la prima deschidere, Setări sistem → Confidențialitate și securitate
        → „Deschide oricum”.
      </p>
    </Card>
  );
}
